import React from "react";

import Footer from "./footer.js";
import Navbar from "./navbar.js";

const Layout = ( { children, categories, selectedCategory } ) => {
	return (
		<>
			<Navbar
				categories         = { categories }
				selectedCategory   = { selectedCategory }
			/>

			{children}

			<Footer />
		</>
	);
};

export default Layout;
